var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M34.857,3.613C20.084-4.861,8.107,2.081,8.107,19.106v125.637c0,17.042,11.977,23.975,26.75,15.509L144.67,97.275c14.778-8.477,14.778-22.211,0-30.686L34.857,3.613z"})));
}

Play.defaultProps = {"className":"play-icon","version":"1.1","fill":"#fff","width":"163.861px","height":"163.861px","viewBox":"0 0 163.861 163.861","xmlSpace":"preserve"};

module.exports = Play;

Play.default = Play;
